import { render, staticRenderFns } from "./CookiesPolicy.vue?vue&type=template&id=336d67af&scoped=true&"
import script from "./CookiesPolicy.vue?vue&type=script&lang=js&"
export * from "./CookiesPolicy.vue?vue&type=script&lang=js&"
import style0 from "./CookiesPolicy.vue?vue&type=style&index=0&id=336d67af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336d67af",
  null
  
)

export default component.exports